<div class="container-fluid content-padded">
  <div class="row">
    <div class="col-md-12" [innerHtml]="content | safeHtml">
    </div>
  </div>
</div>